<div class="chat-faq-screen__title">
  <button
    class="chat-faq-screen__back no-style"
    aria-label="Back to chat"
    (click)="onBackPress()">
    <mat-icon>arrow_back_ios</mat-icon>
  </button>
  <h4>AI Chat FAQ</h4>
</div>

<div class="chat-faq-screen__content">
  <coin-chat-faq-menu
    [helpData]="helpData[languageSelected] ?? []"
    [isLoading]="isHelpDataLoading()" />
</div>
